// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Co-z","slideIn":"Do-z"};